<template>
  <v-container fluid>
    <!-- <v-card>           -->
    <v-row align="end" class="white data-inline-content">
      <v-col cols="6">
        <span class="data-inline-header-content-reference">
          {{ current_qunit.reference }}
        </span>
        <span class="pl-1 data-inline-header-content-title">
          {{ current_qunit.title }}
        </span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="end data-inline-header">
        <v-btn 
          icon
          dense
          @click="copyEmailCode"
        >
          <!-- <div> -->
          <!-- TODO: Copy code to clipboard -->
          <div class="pa-1" style="white-text: nowrap">
            <small class="data-inline-header-copy" style="display: block">
              Copy email code
            </small>
          </div>
          <v-icon right large class="data-inline-header-copy-icon">
            mdi-clipboard-text-multiple
          </v-icon>
          <!-- </div> -->
        </v-btn>
      </v-col>
      <v-col class="data-inline-header" cols="2">
        <span class="label data-inline-header-label"> Reponsible </span>
        <span class="data-inline-header-title">
          {{ current_qunit.current_workflow_responsible }}
        </span>
      </v-col>
      <v-col class="data-inline-header" md="auto">
        <span class="label data-inline-header-label">Límite</span>
        <v-icon
          v-if="
            current_qunit.current_workflow_limit &&
            new Date() >= new Date(current_qunit.current_workflow_limit)
          "
          color="#ff0000"
          small
        >
          mdi-alert-circle
        </v-icon>
        <span
          class=""
          v-if="current_qunit.current_workflow_limit"
          v-bind:class="[
            new Date() >= new Date(current_qunit.current_workflow_limit)
              ? 'data-inline-header-title-date-plan-late'
              : 'data-inline-header-title',
          ]"
        >
          {{
            new Date(current_qunit.current_workflow_limit).toLocaleDateString(
              (options = { dateStyle: 'short' }),
            )
          }}
        </span>
      </v-col>
      <v-col class="data-inline-header-checkbox">
        <!-- <v-checkbox
          v-model="value"
          dense
          hide-details
          class="mr-1 data-inline-header-checkbox"
          @change="toogle"
          :disabled="check_value"
          :value="check_value"
        >
        </v-checkbox> -->
        <v-icon
          v-if="check_value"
          class="mr-3"
        >
            mdi-checkbox-marked
        </v-icon>
        <v-icon 
          v-else 
          @click="toogle" 
          class="mr-3"
        >
          mdi-checkbox-blank-outline
        </v-icon>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels multiple v-model="extended">
        <v-expansion-panel
          v-for="panel in props.layout"
          :key="panel.id"
        >
          <v-expansion-panel-header class="data-inline-expand-header">
            <span class="data-inline-expand-title">{{ panel.title.es }} </span>
            <template v-slot:actions>
              <v-icon 
                class="data-inline-expand-icon"
                @click="changeCheckValue"
              >
                mdi-chevron-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-for="(row, index) in panel.rows" :key="index" >
              <v-col v-for="(col, index) in row" :key="index" :cols="col.cols">
                <div>
                  <span class="data-inline-data-title"> {{ col.label }} </span>
                  <div :class="col.class ? col.class : ['data-inline-data', 'text-justify']" 
                  v-html="col.value">                    
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>
<script>
export default {
  name: 'InlineBoxData',
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      extended: [],
      value: true,
    }
  },
  mounted: function () {
    this.all()
  },
  computed: {
    check_value() {
      // return this.extended.length == this.current_qunit.inline_box_data.length
      return this.extended.length == this.props.layout.length
    }
  },
  methods: {
      // Create an array the length of our items
      // with all values as true
      all () {
        let extend = []
        for (var i=0; i<this.props.layout.length; i++) {
          extend.push(i)
        }
        this.extended = extend
      },
      // Reset the panel
      none () {
        this.extended = []
      },
      toogle(newValue){
        // if (newValue == true) {
        //   this.all()
        // }
        this.all()
      },
      changeCheckValue() {
        if (this.value == true) {
          this.value = false
        }
      },
      copyEmailCode()  {
        let textToCopy = this.current_qunit.uid
        navigator.clipboard.writeText(textToCopy)
      }
    },
}
</script>
<style lang="scss">
@import '@/sass/explorer.scss';
</style>
<style scoped>
.text-block {
    white-space: pre-line; 
}
</style>